export const Images = {
  logo: require('./logo.svg').default,
  cpu: require('./cpu.svg').default,
  'player-vs-player': require('./player-vs-player.svg').default,
  'check-icon': require('./check-icon.svg').default,
  'player-1': require('./player-one.svg').default,
  'player-2': require('./player-two.svg').default,
  'board-layer-black-large': require('./board-layer-black-large.svg').default,
  'board-layer-white-large': require('./board-layer-white-large.svg').default,
  'board-layer-black-small': require('./board-layer-black-small.svg').default,
  'board-layer-white-small': require('./board-layer-white-small.svg').default,
  'counter-red-large': require('./counter-red-large.svg').default,
  'counter-yellow-large': require('./counter-yellow-large.svg').default,
  'counter-red-small': require('./counter-red-small.svg').default,
  'counter-yellow-small': require('./counter-yellow-small.svg').default,
  'turn-background-red': require('./turn-background-red.svg').default,
  'turn-background-yellow': require('./turn-background-yellow.svg').default,
  'marker-red': require('./marker-red.svg').default,
  'marker-yellow': require('./marker-yellow.svg').default,
};
